import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    FormControl,
    FormLabel,
    Grid,
    Card,
    CardContent,
    CircularProgress,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate } from "react-router-dom";
import Crtypto from "../../../Assets/crypto.svg";
import Payeer from "../../../Assets/Payeer.png";
import Radio from "@mui/material/Radio";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const MakeRecharge = () => {
    const navigate = useNavigate();
    const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
    const [isLoading, setIsLoading] = useState(false);


    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
    // Form state
    const [formData, setFormData] = useState({
        amount: "",
        payment_method: "",
    });

    // Error states
    const [errors, setErrors] = useState({
        amount: false,
        payment_method: false,
    });

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: false }));
        }
    };

    const handleMethodChange = (method) => {
        setFormData(prev => ({
            ...prev,
            payment_method: method
        }));

        if (errors.payment_method) {
            setErrors(prev => ({ ...prev, payment_method: false }));
        }
    };

    const handleSubmit = async () => {
        setIsLoading(true);

        // Validate all required fields
        const newErrors = {
            amount: !formData.amount || formData.amount <= 0,
            payment_method: !formData.payment_method,
        };

        setErrors(newErrors);

        // Check if any errors exist
        if (Object.values(newErrors).some(error => error)) {
            showCenteredPopup("Please fill all required fields",
                { variant: "error",
                    persist: true });
            // enqueueSnackbar("Please fill all required fields", {
            //     variant: "error",
            //     persist: true,
            //     action,
            //     anchorOrigin: {
            //         vertical: "top",
            //         horizontal: "right",
            //     },
            // });
            setIsLoading(false);
            return;
        }

        // Prepare form data
        const data = new FormData();
        data.append('amount', formData.amount);
        data.append('payment_method', formData.payment_method);

        // Use Helper.Post as is
        const { response, message } = await Helper.Post({
            url: api_Routes.Balance.deposit,
            hasToken: true,
            data: data,
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response) {
            showCenteredPopup("Redirecting to payment gateway...",
                { variant: "info",
                    persist: true });
            // enqueueSnackbar("Redirecting to payment gateway...", {
            //     variant: "info",
            //     persist: true,
            //     action,
            // });

            // Redirect to the payment gateway
            if (response.data.redirect_url) {
                window.location.href = response.data.redirect_url;
            } else {
                showCenteredPopup("Payment initiated successfully",
                    { variant: "success",
                        persist: true });
                // enqueueSnackbar("Payment initiated successfully", {
                //     variant: "success",
                //     persist: true,
                //     action,
                // });
                navigate("/dashboard/balance");
            }
        } else {
            // Handle API errors
            if (typeof message === "string") {
                showCenteredPopup(message,
                    { variant: "error",
                        persist: true });
                // enqueueSnackbar(message, {
                //     variant: "error",
                //     persist: true,
                //     action,
                // });
            } else if (message?.errors) {
                Object.values(message.errors).flat().forEach(errorMessage => {
                    showCenteredPopup(errorMessage,
                        { variant: "error",
                            persist: true });
                    // enqueueSnackbar(errorMessage, {
                    //     variant: "error",
                    //     persist: true,
                    //     action,
                    // });
                });
            } else if (message?.message) {
                showCenteredPopup(message.message,
                    { variant: "error",
                        persist: true });
                // enqueueSnackbar(message.message, {
                //     variant: "error",
                //     persist: true,
                //     action,
                // });
            } else {
                showCenteredPopup("An error occurred. Please try again.",
                    { variant: "error",
                        persist: true });
                // enqueueSnackbar("An error occurred. Please try again.", {
                //     variant: "error",
                //     persist: true,
                //     action,
                // });
            }
        }

        setIsLoading(false);
    };

    return (
        <Box sx={{ maxWidth: 800, margin: "auto", p: 3 }}>
            <Typography variant="h4" gutterBottom>
                Recharge Balance
            </Typography>

            {/* Amount Input */}
            <TextField
                fullWidth
                label="Amount *"
                name="amount"
                type="number"
                value={formData.amount}
                onChange={handleFormChange}
                error={errors.amount}
                helperText={errors.amount && "Amount is required and must be greater than 0"}
                sx={{ mb: 3 }}
                inputProps={{ min: 1 }}
            />

            {/*/!* Payment Methods *!/*/}
            <FormControl component="fieldset" error={errors.payment_method} sx={{ mb: 3,width:'100%' }}>
                <FormLabel component="legend">Payment Method *</FormLabel>
                {/*<Grid container spacing={2}>*/}
                {/*    <Grid item xs={12} md={6}>*/}
                {/*        <Card*/}
                {/*            variant="outlined"*/}
                {/*            sx={{*/}
                {/*                cursor: 'pointer',*/}
                {/*                borderColor: formData.payment_method === 'cryptomus' ? 'primary.main' : 'divider',*/}
                {/*                backgroundColor: formData.payment_method === 'cryptomus' ? 'action.selected' : 'background.paper'*/}
                {/*            }}*/}
                {/*            onClick={() => handleMethodChange('cryptomus')}*/}
                {/*        >*/}
                {/*            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>*/}
                {/*                <Radio*/}
                {/*                    checked={formData.payment_method === 'cryptomus'}*/}
                {/*                    onChange={() => handleMethodChange('cryptomus')}*/}
                {/*                    value="cryptomus"*/}
                {/*                    color="primary"*/}
                {/*                />*/}
                {/*                <img*/}
                {/*                    src={Crtypto}*/}
                {/*                    alt="Cryptomus"*/}
                {/*                    style={{ height: 24, marginRight: 8 }}*/}
                {/*                />*/}
                {/*                <Typography>Cryptomus</Typography>*/}
                {/*            </CardContent>*/}
                {/*        </Card>*/}
                {/*    </Grid>*/}
                {/*    <Grid item xs={12} md={6}>*/}
                {/*        <Card*/}
                {/*            variant="outlined"*/}
                {/*            sx={{*/}
                {/*                cursor: 'pointer',*/}
                {/*                borderColor: formData.payment_method === 'payeer' ? 'primary.main' : 'divider',*/}
                {/*                backgroundColor: formData.payment_method === 'payeer' ? 'action.selected' : 'background.paper'*/}
                {/*            }}*/}
                {/*            onClick={() => handleMethodChange('payeer')}*/}
                {/*        >*/}
                {/*            <CardContent sx={{ display: 'flex', alignItems: 'center' }}>*/}
                {/*                <Radio*/}
                {/*                    checked={formData.payment_method === 'payeer'}*/}
                {/*                    onChange={() => handleMethodChange('payeer')}*/}
                {/*                    value="payeer"*/}
                {/*                    color="primary"*/}
                {/*                />*/}
                {/*                <img*/}
                {/*                    src={Payeer}*/}
                {/*                    alt="Payeer"*/}
                {/*                    style={{ height: 24, marginRight: 8 }}*/}
                {/*                />*/}
                {/*                <Typography>Payeer</Typography>*/}
                {/*            </CardContent>*/}
                {/*        </Card>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
                <Typography variant="h4" color="error">
                    There Was some issues with payment methods please contact admin
                </Typography>
                {errors.payment_method && (
                    <Typography variant="caption" color="error">
                        Please select a payment method
                    </Typography>
                )}
            </FormControl>

            {/*/!* Discount Information *!/*/}
            {/*<Box sx={{ mb: 3, p: 2, bgcolor: 'warning.light', borderRadius: 1 }}>*/}
            {/*    <Typography variant="body2">*/}
            {/*        Get 5% bonus when you recharge using Cryptomus or Payeer!*/}
            {/*    </Typography>*/}
            {/*</Box>*/}

            {/*/!* Submit Button *!/*/}
            {/*<Button*/}
            {/*    variant="contained"*/}
            {/*    color="primary"*/}
            {/*    onClick={handleSubmit}*/}
            {/*    disabled={isLoading}*/}
            {/*    fullWidth*/}
            {/*    size="large"*/}
            {/*    startIcon={isLoading ? <CircularProgress size={20} /> : null}*/}
            {/*>*/}
            {/*    {isLoading ? "Processing..." : "Recharge Balance"}*/}
            {/*</Button>*/}
        </Box>
    );
};

export default MakeRecharge;